import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sizes" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle" }, " Quel tarif pour stocker ? ", -1)
const _hoisted_3 = ["id", "box-id"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { style: {"width":"auto","padding":"0.5em"} }
const _hoisted_7 = { style: {"font-weight":"bold","font-size":"0.9em"} }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  style: {"margin":"0.5em 0 0","padding-left":"1.2em"}
}
const _hoisted_14 = {
  class: "search-box-price",
  style: {}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, " Voir prix ", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "textPrice" }
const _hoisted_20 = { style: {"position":"relative","font-size":"8pt","top":"0.3em"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" TTC / mois ")
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, "au lieu de", -1)
const _hoisted_24 = { style: {"font-weight":"bold","font-size":"1.25em"} }
const _hoisted_25 = { class: "search-button-view-box" }
const _hoisted_26 = { id: "box-plus-form" }
const _hoisted_27 = {
  key: 0,
  class: "loading"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, "Traitement de la demande...", -1)
const _hoisted_29 = {
  key: 1,
  class: "success"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, "Demande traitée avec succès !", -1)
const _hoisted_31 = { key: 2 }
const _hoisted_32 = { id: "box-h2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "Nom :", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Prénom :", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "Adresse e-mail :", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "Numéro de téléphone :", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Date de location :", -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "Vous avez une question ?", -1)
const _hoisted_40 = { style: {"text-align":"center"} }
const _hoisted_41 = {
  type: "submit",
  name: "reservation_confirm",
  id: "reservation_confirm",
  class: "button"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "no-mobile",
  style: {"text-align":"center","margin":"5px auto"}
}, " Gratuit et sans engagement ", -1)
const _hoisted_43 = {
  key: 0,
  class: "error-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.boxes( this.store.state.gm.boxes ), (box, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: (box.type + '_' + box.id),
        id: 'box_' + box.id,
        "box-id": box.id,
        class: _normalizeClass('gm-details-box' + ( (this.selected_box && this.selected_box.id === box.id) ? '-selected' : '' ) )
      }, [
        (box.link)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              rel: "nofollow noopener",
              target: "_blank",
              onClick: _withModifiers(($event: any) => (this.store.state.counter( 'boxlink', _ctx.gm.id, () => this.window.open( box.link, '_blank' ).focus() )), ["prevent"]),
              style: {"position":"absolute","width":"100%","height":"100%","z-index":"997"}
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("table", {
          onClick: ($event: any) => (box.link ? '' : this.selectBox(box)),
          style: {"width":"100%","min-height":"3em"}
        }, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("b", {
                  innerHTML: box.type_name
                }, null, 8, _hoisted_8),
                _hoisted_9,
                _createElementVNode("span", {
                  innerHTML: box.size
                }, null, 8, _hoisted_10),
                _hoisted_11,
                _createElementVNode("span", {
                  innerHTML: box.unit.replace('3', '<sup>3</sup>').replace('2', '<sup>2</sup>')
                }, null, 8, _hoisted_12)
              ]),
              (box.services.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                    (box.services[index] !== '')
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(box.services, (box_service, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            style: {"margin":"0.5em 0 0","font-size":"0.75em","line-height":"110%"}
                          }, _toDisplayString(box_service), 1))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", { class: "box-promo" }, _toDisplayString(box.promo), 513), [
                [_vShow, box.promo]
              ])
            ]),
            _createElementVNode("td", _hoisted_14, [
              (box.price.show === false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true),
              (box.price.show === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("b", _hoisted_19, _toDisplayString(box.price.normal.toFixed( 2 )) + "€ ", 1),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      (box.price.strike > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("del", _hoisted_24, _toDisplayString(box.price.strike) + "€ ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_25, [
              (this.selected_box === box)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "caret-up"
                  }))
                : _createCommentVNode("", true),
              (typeof this.selected_box.id === 'undefined')
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "caret-down"
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ], 8, _hoisted_5)
      ], 10, _hoisted_3)), [
        [_vShow, ( typeof this.selected_box.id === 'undefined' ) || ( this.selected_box === box ) ]
      ])
    }), 128)),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_26, [
          (this.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_font_awesome_icon, {
                  icon: "spinner",
                  pulse: ""
                })
              ]))
            : _createCommentVNode("", true),
          (this.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_font_awesome_icon, { icon: "check-circle" })
              ]))
            : _createCommentVNode("", true),
          (!this.loading && !this.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("h2", _hoisted_32, _toDisplayString(this.selected_box.price && this.selected_box.price.show === false ? 'Voulez-vous obtenir le tarif de ce box ?' : 'Voulez-vous vérifier la disponibilité de ce box ?'), 1),
                _createElementVNode("form", {
                  onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (this.submit()), ["prevent"])),
                  method: "post",
                  id: "resa_form_element"
                }, [
                  _createElementVNode("label", null, [
                    _hoisted_33,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "text",
                      name: "reservation_name",
                      id: "reservation_name",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.reservation_name) = $event)),
                      placeholder: "Nom",
                      class: "box-plus-form-input"
                    }, null, 512), [
                      [_vModelText, this.reservation_name]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _hoisted_34,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "text",
                      name: "reservation_surname",
                      id: "reservation_surname",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.reservation_surname) = $event)),
                      placeholder: "Prénom",
                      class: "box-plus-form-input"
                    }, null, 512), [
                      [_vModelText, this.reservation_surname]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _hoisted_35,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "email",
                      name: "reservation_email",
                      id: "reservation_email",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.reservation_email) = $event)),
                      placeholder: "Ex: exemple@exemple.com",
                      class: "box-plus-form-input"
                    }, null, 512), [
                      [_vModelText, this.reservation_email]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _hoisted_36,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "text",
                      name: "reservation_phone",
                      id: "reservation_phone",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.reservation_phone) = $event)),
                      placeholder: "Ex: 06 66 66 66 66",
                      class: "box-plus-form-input"
                    }, null, 512), [
                      [_vModelText, this.reservation_phone]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _hoisted_37,
                    _withDirectives(_createElementVNode("input", {
                      required: "",
                      type: "date",
                      name: "reservation_date",
                      id: "reservation_date",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.reservation_date) = $event)),
                      placeholder: "JJ-MM-AAAA",
                      autocomplete: "off"
                    }, null, 512), [
                      [_vModelText, this.reservation_date]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    (!this.question_shown)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "#",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (this.question_shown = true), ["prevent"])),
                          style: {"font-weight":"bold"}
                        }, " Vous avez une question ? "))
                      : _createCommentVNode("", true),
                    (this.question_shown)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("textarea", {
                            type: "text",
                            name: "reservation_question",
                            id: "reservation_question",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.reservation_question) = $event)),
                            placeholder: "Posez votre question ici...",
                            autocomplete: "off"
                          }, null, 512), [
                            [_vModelText, this.reservation_question]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("label", _hoisted_40, [
                    _createElementVNode("button", _hoisted_41, _toDisplayString(this.selected_box.price && this.selected_box.price.show ? 'Recevoir votre devis' : 'Envoyer la demande'), 1)
                  ]),
                  _hoisted_42,
                  (this.error && this.error.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(this.error), 1))
                    : _createCommentVNode("", true)
                ], 32)
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, (typeof this.selected_box.id !== 'undefined')]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("button", {
      onClick: _cache[8] || (_cache[8] = ($event: any) => {this.box_shown = this.box_shown + 4;}),
      class: "button",
      style: {"display":"block","margin":"10px auto","width":"100%","font-size":"1em"}
    }, " Afficher plus de tailles ", 512), [
      [_vShow, this.box_shown <= this.store.state.gm.boxes.length && ( typeof this.selected_box.id === 'undefined' )]
    ])
  ]))
}